// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_y7A","cls2":"SimplePaperPodcast-cls2_Tei SimplePaperPodcast-cls1_y7A"};